import React, { useState } from 'react';
import '../css/Project.css';
import ButtonLarge from '../components/Button-large';
import { useNavigate } from 'react-router-dom';
import Chip from './Chip';

const Project = ({ title, description, image, imageAlt, buttonLabel, to, disabled, chipLabelA, chipLabelB, chipLabelC }) => {
  const navigate = useNavigate();

  // State to manage hover
  const [isHovered, setIsHovered] = useState(false);

  // Function to handle navigation
  const handleNavigate = () => {
    if (!disabled) {
      navigate(to);
    }
  };

  return (
    <div
      className="project"
      
    >
      <div className="project-menu">
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleNavigate}
          style={{ cursor: disabled ? 'not-allowed' : 'pointer', backgroundImage: `url(${image})`}}
          className={`project-cover ${isHovered ? 'hovered' : ''}`}
        />
        
        <div
          className={`project-info ${isHovered ? 'hovered' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleNavigate}
          style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
          <div className="chips-container">
        <Chip
            className="chip"
            label={chipLabelA}
            setIsButtonHovered={setIsHovered} // Pass the hover function
            to={to}
            disabled={disabled}
            variant='outlined'
          />
        <Chip
            className="chip"
            label={chipLabelB}
            setIsButtonHovered={setIsHovered} // Pass the hover function
            to={to}
            disabled={disabled}
            variant='outlined'
          />
        <Chip
            className="chip"
            label={chipLabelC}
            setIsButtonHovered={setIsHovered} // Pass the hover function
            to={to}
            disabled={disabled}
            variant='outlined'
        />
        </div>
          <h3 className={isHovered ? 'hovered' : ''}>{title}</h3>
          <p>{description}</p>
          <ButtonLarge
            className="button-large"
            label={buttonLabel}
            setIsButtonHovered={setIsHovered} // Pass the hover function
            to={to}
            disabled={disabled}
            variant='filled'
          />
        </div>
      </div>
    </div>
  );
};

export default Project;

